import type { VoidFunctionComponent } from 'react';

import { BadgeTypes, getBadgeImageUrl } from './utils';
import type { BadgeBaseProps, BadgeType } from './types';

import styles from './BadgePanel.module.less';

type Props = BadgeBaseProps & {
  badgeType: BadgeType;
  onLoad?: () => void;
  onClick?: () => void;
};

/**
 * Renders a StatusBadge, which is a GitHub-style "shield" badge.
 * This can be clicked so the user can get info on embedding this
 * badge in their project's README files.
 */
const StatusBadge: VoidFunctionComponent<Props> = ({ locator, badgeType, onLoad, onClick }) => {
  if (!locator) {
    return null;
  }

  const badgeInfo = BadgeTypes[badgeType];
  const badgeImageURL = getBadgeImageUrl(locator, badgeInfo.badgeType, badgeInfo.issueType, true);
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    <img
      src={badgeImageURL}
      alt={badgeInfo.altText || 'FOSSA Badge'}
      className={styles.statusBadgeImg}
      onLoad={onLoad}
      onClick={onClick}
  />
  );
};

export default StatusBadge;
